<div class="row">
    <div class="col-sm-6">
        <h4>Lista de tenologías emergentes</h4>
    </div>
    <ng-container *ngIf="accessMP===true">
        <div class="col-sm-6 text-end">
            <a [routerLink]="['../add', selectedT1]" class="btn-add">
                <i class="fa fa-plus px-2"></i> Agregar nueva tecnología
            </a>
        </div>
    </ng-container>
</div>
<div class="row">
    <div class="table-responsive">
        <table class="table">
            <thead class="thead-detail text-center table-success">
                <tr>
                    <th scope="col">N°</th>
                    <th scope="col">Código</th>
                    <th scope="col">Nombre largo</th>
                    <th scope="col">Versión</th>
                    <th scope="col">Temática</th>
                    <th scope="col">Actualización</th>
                    <th scope="col">Estado</th>
                    <th scope="col">Secciones</th>
                    <th scope="col">Gráficos</th>
                    <th scope="col">Bibliografía</th>
                    <th scope="col">Fuente primaria</th>
                    <th scope="col" style="min-width: 40px;"></th>
                    <ng-container *ngIf="accessME===true">
                        <th scope="col" style="min-width: 40px;"></th>
                    </ng-container>
                    <ng-container *ngIf="accessMD===true">
                        <th scope="col" style="min-width: 40px;"></th>
                    </ng-container>
                </tr>
            </thead>
            <tbody>
                <tr class="tbody-detail" *ngFor="let obj of t3; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td class="text-center">{{ obj.code }}</td>
                    <td>{{ obj.longtitle }}</td>
                    <td class="text-center">{{ obj.version }}</td>
                    <td class="text-center" [ngStyle]="{'color': obj.color}"><b>{{ obj.tematic }}</b></td>
                    <td class="text-center">{{ obj.lastUpdated | date:'MM/yyyy' }}</td>
                    <td class="text-center">
                        <div class="label-active" *ngIf="obj.status">ACTIVO</div>
                        <div class="label-inactive" *ngIf="!obj.status">INACTIVO</div>
                    </td>
                    <td class="text-center"><a class="a-icon" [routerLink]="['/adm/seccion/list', obj.id]"><i
                                class="fa fa-align-justify i-icon"></i></a></td>
                    <td class="text-center"><a class="a-icon" [routerLink]="['/adm/grafico/list', obj.id]"><i
                                class="fa fa-bar-chart i-icon"></i></a></td>
                    <td class="text-center"><a class="a-icon" [routerLink]="['/adm/bibliografia/list', obj.id]"><i
                                class="fa fa-book i-icon"></i></a></td>
                    <td class="text-center"><a class="a-icon" [routerLink]="['/adm/fuente/list', obj.id]"><i
                                class="fa fa-bookmark i-icon"></i></a></td>
                    <ng-container *ngIf="accessME===true">
                        <td class="text-center"><a class="a-icon" [routerLink]="['/adm/tecnologia/edit', obj.id]"><i
                                    class="fa fa-pencil i-icon"></i></a></td>
                    </ng-container>
                    <ng-container *ngIf="accessMD===true">
                        <td class="text-center"><a class="a-icon" routerLink=""><i class="fa fa-trash i-icon"></i></a>
                        </td>
                    </ng-container>
                </tr>
            </tbody>
        </table>
    </div>
</div>